import once from "lodash/once";

import * as envService from "../services/env";

import {
  AppDepsByName,
  SharedFabricDeps,
  addToAppDeps,
  addToSharedFabricDeps,
} from "./deps.helpers.private";

export const getAppDeps = (appEnv: envService.Env): AppDepsByName => {
  const appPackageJsonDeps = envService.getAppPackageJsonDeps(appEnv);
  const appPackageJsonDevDeps = envService.getAppPackageJsonDevDeps(appEnv);
  const appActualDepVersions = envService.getAppActualDepVersions(appEnv);
  const appFabricCoreAllSharedDepNames =
    envService.getAppFabricCoreAllSharedDepNames(appEnv);
  const sharedFabricCorePackageJsonDeps =
    envService.getSharedFabricCorePackageJsonDeps();

  const appDeps: AppDepsByName = {};

  // Add dep info for all known Fabric shared deps as shared deps.
  // These may not all be installed in this app. That's ok.
  appFabricCoreAllSharedDepNames.forEach((depName) => {
    if (!appActualDepVersions[depName]) {
      // Skip if this dep is not actually installed in this app
      return;
    }
    addToAppDeps(appEnv, appDeps, depName, true);
  });

  // Add dep info for all @granular/fabric-core package.json deps as shared deps.
  // These may not all be installed in this app yet. That's ok.
  // The message that the app is behind on its @granular/fabric-core version will suffice.
  Object.keys(sharedFabricCorePackageJsonDeps).forEach((depName) => {
    if (!appActualDepVersions[depName]) {
      // Skip if this dep is not actually installed in this app
      return;
    }
    addToAppDeps(appEnv, appDeps, depName, true);
  });

  // Add dep info for all app package.json devDeps as shared deps.
  Object.keys(appPackageJsonDevDeps).forEach((depName) => {
    addToAppDeps(appEnv, appDeps, depName, true);
  });

  // Add dep info for all app package.json deps as non-shared deps.
  // This *must* be run last as it needs to overwrite any above entries for this dep.
  Object.keys(appPackageJsonDeps).forEach((depName) => {
    addToAppDeps(appEnv, appDeps, depName, false);
  });

  return appDeps;
};

export const getSharedFabricDeps = once((): SharedFabricDeps => {
  const sharedFabricDeps: SharedFabricDeps = {};

  const sharedFabricCoreSharedSingleDepNames =
    envService.getSharedFabricCoreSharedSingleDepNames();
  const sharedFabricCoreSharedFlexDepNames =
    envService.getSharedFabricCoreSharedFlexDepNames();

  sharedFabricCoreSharedSingleDepNames.forEach((depName) => {
    addToSharedFabricDeps(sharedFabricDeps, depName, "single");
  });

  sharedFabricCoreSharedFlexDepNames.forEach((depName) => {
    addToSharedFabricDeps(sharedFabricDeps, depName, "flex");
  });

  return sharedFabricDeps;
});
